<template>
  <div class="content" id="d1">
    <div v-if="isShow" class="none">暂无班级</div>
    <div class="main clearfix" v-else>
      <div class="class-list-div" v-for="item in this.classList" :key="item.classid" @click="toClassSpace(item)">
        <p class="class-p1">{{item.grade+item.classno}}班</p>
        <p class="class-p2">{{item.slogan}}</p>
        <img v-if="item.logo_img_file" :src="item.logo_img_file" class="class-img" style="cursor:pointer;" />
        <img v-else src="../../assets/img/banji.png" class="class-img" style="cursor:pointer;" />
      </div>
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
import { log } from "util";
export default {
  name: "MyClass",
  data() {
    return {
      isShow: false, // 是否显示缺省页
      classList: [],
    };
  },

  created() {},
  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    globalVaranthasInited: function () {
      this.init();
    },
  },
  methods: {
    init() {
      this.owner_id = this.$route.query.userid; // 教师空间id

      if (this.owner_id == undefined) {
        this.$router.push("error");
        return false;
      }

      this.GetClassByTeacher(); // 获取某个老师所教的班级
    },
    // 获取某个老师所教的班级
    async GetClassByTeacher() {
      const data = {
        s: "WebTeacherSpace.MyClass.GetClassByTeacher",
        userid: this.owner_id,
      };
      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.classList = res.data.data;
      this.count = this.classList.length;
      this.count == undefined ? (this.isShow = true) : (this.isShow = false);
    },

    // 跳转班级空间
    toClassSpace(item) {
      globalApi.jumpPath(6, "home", "classid=" + item.classid);
    },
  },
};
</script>
<style>
</style>

<style lang="scss" scoped>
.clearfix {
  clear: both;
  overflow: hidden;
  zoom: 1;
}
.content {
  min-height: 950px;
}
.el-pagination {
  text-align: center;
  padding: 20px 0;
}
.main {
  width: 1180px;
  border-radius: 4px;
  margin: auto;
  padding-top: 20px;
  padding-bottom: 100px;
}
.class-list-div {
  width: 273px;
  height: 220px;
  float: left;
  margin: 10px 5px 10px 5px;
  padding: 5px;
  background: rgba(255, 255, 255, 1);
  font-family: Microsoft YaHei;
  p {
    height: 20px;
    line-height: 20px;
    margin-left: 5px;
  }
  .class-p1 {
    font-size: 16px;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    padding: 5px 0 0 0;
  }
  .class-p2 {
    font-size: 14px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
    padding: 5px 0 5px 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 15rem;
  }
  .class-img {
    width: 264px;
    height: 161px;
    margin-left: 5px;
  }
}
.none {
  height: 480px;
  line-height: 620px;
  text-align: center;
  background: url(../../assets/img/home_img_2.png) no-repeat center 100px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
</style>